import PropTypes from 'prop-types';

import { list } from './styles.module.scss';

export const DescriptionList = ({ children }) => {
  return <dl className={list}>{children}</dl>;
};

DescriptionList.propTypes = {
  children: PropTypes.node.isRequired
};
